import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Loader2, CheckCircle2, ArrowRight } from "lucide-react";
import { trackLeadConversion } from "@/lib/analytics";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const inputCls = "h-12 rounded-xl bg-white border-cream-300 text-sand-800 placeholder:text-sand-400 focus-visible:ring-terra";

/** Kompaktes Lead-Formular für Ads-Landing-Pages. */
export default function LpLeadForm({ source, audience, heading = "Kostenlose Beratung sichern", sub }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await axios.post(`${API}/leads`, { ...form, audience, source });
      trackLeadConversion(5, source);
      setDone(true);
    } catch {
      toast.error("Anfrage konnte nicht gesendet werden – ruf uns gern direkt an: 0211 29273330.");
    }
    setSubmitting(false);
  };

  if (done) {
    return (
      <div data-testid="lp-lead-success" className="rounded-3xl bg-white border border-cream-300 p-10 text-center shadow-soft">
        <CheckCircle2 className="h-12 w-12 text-sage-dark mx-auto mb-4" strokeWidth={1.4} />
        <h3 className="font-display text-2xl text-sand-800">Anfrage erhalten!</h3>
        <p className="text-sand-600 text-[14.5px] mt-2">Wir melden uns innerhalb von 24 Stunden bei dir – meist deutlich schneller.</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid="lp-lead-form" className="rounded-3xl bg-white border border-cream-300 p-7 sm:p-9 shadow-soft space-y-4">
      <h3 className="font-display text-2xl text-sand-800">{heading}</h3>
      {sub && <p className="text-sand-600 text-[13.5px] leading-relaxed">{sub}</p>}
      <Input data-testid="lp-lead-name" className={inputCls} required minLength={2} placeholder="Name *"
        value={form.name} onChange={set("name")} />
      <div className="grid sm:grid-cols-2 gap-4">
        <Input data-testid="lp-lead-email" className={inputCls} type="email" required placeholder="E-Mail *"
          value={form.email} onChange={set("email")} />
        <Input data-testid="lp-lead-phone" className={inputCls} type="tel" required minLength={4} placeholder="Telefon *"
          value={form.phone} onChange={set("phone")} />
      </div>
      <Textarea data-testid="lp-lead-message" rows={3} placeholder="Deine Frage (optional)"
        className="rounded-xl bg-white border-cream-300 text-sand-800 placeholder:text-sand-400 focus-visible:ring-terra"
        value={form.message} onChange={set("message")} />
      <Button type="submit" disabled={submitting} data-testid="lp-lead-submit"
        className="w-full rounded-full bg-terra hover:bg-terra-dark text-white h-13 py-3.5 text-base font-semibold group">
        {submitting ? <Loader2 className="h-4 w-4 animate-spin" /> : (
          <>Jetzt unverbindlich anfragen<ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" strokeWidth={1.8} /></>
        )}
      </Button>
      <p className="text-[11.5px] text-sand-500 leading-relaxed">
        Unverbindlich & kostenlos. Wir melden uns innerhalb von 24 h.
      </p>
    </form>
  );
}

